// extracted by mini-css-extract-plugin
export var subtitle = "_bc-2";
export var title = "_bc-0";
export var titleNoWrap = "_bc-1";